// Common Client V2 imports
const {
  ARTICLE_DOMAIN_BLOCKED,
  ARTICLE_LOADED,
  ARTICLES_REPORTED
} = require('client-v2/common/models/article/actions')
const {
  INTEREST_FOLLOWING_CHANGE
} = require('client-v2/common/models/interest/actions')
const interestReducer = require('client-v2/common/models/interest/reducer')
const articleModelReducer = require('client-v2/common/models/article/reducer')
// Container imports
const {
  COLLECTIONS_FAILED,
  COLLECTIONS_LOADED,
  COLLECTIONS_LOADING,
  COLLECTIONS_RESET,
  COMMENTS_FAILED,
  COMMENTS_LOADED,
  COMMENTS_LOADING,
  CURATOR_LOADED,
  INTERESTS_FAILED,
  INTERESTS_LOADED,
  INTERESTS_LOADING,
  RELATED_FAILED,
  RELATED_LOADED,
  RELATED_LOADING,
  COMMENT_DELETED,
  SELECT_TAB
} = require('./slide-actions')
const ArticleProfileSlideRecord = require('./slide-record')

/* eslint-disable complexity */
function articleProfileSlideReducer(state = new ArticleProfileSlideRecord(), action) {
  const { type, payload = {} } = action
  if (payload.urlId !== state.article['url_id']) {
    // Pass the action along to interest models
    if (type === INTEREST_FOLLOWING_CHANGE) {
      return state.update('interestsItems', interestsItems => {
        return interestsItems.map(interest => {
          return interestReducer(interest, action)
        })
      })
    }
    // Pass the action along to related stream items
    if (state.relatedStream) {
      return state.update('relatedStream', relatedStream => {
        switch (type) {
          case ARTICLE_DOMAIN_BLOCKED:
            return relatedStream.removeArticlesByHostname(payload.hostname)
          case ARTICLES_REPORTED:
            return relatedStream.removeArticlesByUrlIds(payload.urlIds)
          default:
            return relatedStream.itemsReducer(action)
        }
      })
    }
    return state
  }
  switch (type) {
    case COLLECTIONS_FAILED:
      return state.setCollectionsFailed()
    case COLLECTIONS_LOADED:
      return state.addCollections(payload)
    case COLLECTIONS_LOADING:
      return state.setCollectionsLoading()
    case COLLECTIONS_RESET:
      return state.resetCollections()
    case COMMENTS_FAILED:
      return state.setCommentsFailed()
    case COMMENTS_LOADED:
      return state.addComments(payload)
    case COMMENTS_LOADING:
      return state.setCommentsLoading()
    case CURATOR_LOADED:
      return state.setCurator(payload)
    case INTERESTS_FAILED:
      return state.setInterestsFailed()
    case INTERESTS_LOADED:
      return state.addInterests(payload)
    case INTERESTS_LOADING:
      return state.setInterestsLoading()
    case RELATED_FAILED:
      return state.setRelatedFailed()
    case RELATED_LOADED:
      return state.addRelated(payload)
    case RELATED_LOADING:
      return state.setRelatedLoading()
    case COMMENT_DELETED:
      return state.removeComment(payload.commentId)
    case SELECT_TAB:
      return state.setSelectedTab(payload.selectedTab)
    case ARTICLE_LOADED:
      return state.setArticle(payload.article)
    default:
      return state.update('article', article => {
        return articleModelReducer(article, action)
      })
  }
}
/* eslint-enable complexity */

module.exports = articleProfileSlideReducer
